import { assessmentMeasurementUpdateDetailSchema, } from './assessment-measurement-update-detail.js';
import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
export const assessmentMeasurementUpdatesSchema = z.object({
    updateReasons: z.array(z.string()),
    updateDetails: z.record(z.string(), assessmentMeasurementUpdateDetailSchema),
});
export function toAssessmentMeasurementUpdates(updates) {
    const result = assessmentMeasurementUpdatesSchema.safeParse(updates);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssessmentMeasurementUpdates object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assessment-measurement-updates.js.map